// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"39169476","611":"c522dc63","761":"a09c248e","947":"bd0ece9f"}[chunkId] + ".chunk.js";
};